/* eslint-disable  max-len */

import React from 'react';
import PropTypes from 'prop-types';

import trackAction from 'utils/tracking';

import { ACTION_NODE_LINK, ACTION_TYPE_PRIMARY, ACTION_TYPE_SECONDARY } from 'constants/Action';
import Cta from 'components/Core/Cta';

const Page404 = ({ errorContent }) => {
  const title = '404';
  const description = 'Oeps, je bent te diep gezwommen! Deze pagina is niet beschikbaar.';
  const { primaryLinkText, secondaryLinkText, secondaryLinkPage } = errorContent;
  const hasSecondary = secondaryLinkText && secondaryLinkPage && secondaryLinkPage.url;
  return (
    <div className="w-10/12 md:8/12 container mx-auto py-4 md:py-8 lg:py-12 text-center flex flex-col justify-center lg:min-h-errorContainerLg">
      <h1 className="text-6xl lg:text-50 leading-32 lg:leading-52 text-white">{title}</h1>
      <p className="text-2xl lg:text-3xl leading-9 py-8">{description}</p>

      <div className="flex flex-col md:flex-row justify-center content-center py-8 lg:py-20">
        <Cta
          node={ACTION_NODE_LINK}
          href="/"
          styleType={ACTION_TYPE_PRIMARY}
          onClick={() => {
            trackAction('error', primaryLinkText, 'click');
          }}
        >
          {primaryLinkText}
        </Cta>
        {hasSecondary && (
          <Cta
            className="mt-4 md:mt-0 md:ml-4"
            node={ACTION_NODE_LINK}
            href="/[...slug]"
            as={secondaryLinkPage.url}
            styleType={ACTION_TYPE_SECONDARY}
            onClick={() => {
              trackAction('error', secondaryLinkText, 'click');
            }}
          >
            {secondaryLinkText}
          </Cta>
        )}
      </div>
    </div>
  );
};

Page404.defaultProps = {
  errorContent: {
    primaryLinkText: 'Terug naar home',
    secondaryLinkText: null,
    secondaryLinkPage: null,
  },
};

Page404.propTypes = {
  errorContent: PropTypes.shape({
    primaryLinkText: PropTypes.string,
    secondaryLinkText: PropTypes.string,
    secondaryLinkPage: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  }),
};
export default Page404;
